document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.getElementById('MobileNav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var isOpen = !nav.hidden;
    nav.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
});
